import React, { useEffect, useState } from 'react';
import './index.css';
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { auth, db } from '../../firebaseConfig';
import { toast } from 'react-hot-toast';

const UpdateProfile = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    address: '',
    phone: '',
    panNumber: '',
    aadharNumber: '',
  });

  const [loading, setLoading] = useState(true);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const fetchUserDetails = async () => {
    const user = auth.currentUser;
    if (user) {
      try {
        const docRef = doc(db, 'users', user.uid, 'memberDetails', 'profile');
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setFormData(docSnap.data());
        }
      } catch (err) {
        toast.error('Failed to fetch user data');
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchUserDetails();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const user = auth.currentUser;
    if (user) {
      try {
        const docRef = doc(db, 'users', user.uid, 'memberDetails', 'profile');
        await setDoc(docRef, formData);
        toast.success('Profile updated successfully');
        setIsSubmitted(true);
      } catch (err) {
        toast.error('Error updating profile');
      }
    }
  };

  if (loading) return (
    <div className="spinner-container">
      <div className="spinner"></div>
    </div>
  );

  return (
    <div className="update-profile-container">
      <h2>Your Profile</h2>

      {!isSubmitted ? (
        <form onSubmit={handleSubmit} className="update-profile-form">
          <div className="form-group">
            <label>Name</label>
            <input type="text" name="name" value={formData.name} onChange={handleChange} required />
          </div>
          <div className="form-group">
            <label>Email</label>
            <input type="email" name="email" value={formData.email} onChange={handleChange} required />
          </div>
          <div className="form-group">
            <label>Address</label>
            <textarea name="address" value={formData.address} onChange={handleChange} required />
          </div>
          <div className="form-group">
            <label>Phone Number</label>
            <PhoneInput
              defaultCountry="IN"
              international
              countryCallingCodeEditable={false}
              value={formData.phone}
              onChange={(phone) => setFormData((prev) => ({ ...prev, phone }))}
              required
            />
          </div>
          <div className="form-group">
            <label>PAN Number</label>
            <input type="text" name="panNumber" value={formData.panNumber} onChange={handleChange} required />
          </div>
          <div className="form-group">
            <label>Aadhar Number</label>
            <input type="text" name="aadharNumber" value={formData.aadharNumber} onChange={handleChange} required />
          </div>
          <button type="submit" className="submit-btn">Save Profile</button>
        </form>
      ) : (
        <div className="profile-card">
          <p><strong>Name:</strong> {formData.name}</p>
          <p><strong>Email:</strong> {formData.email}</p>
          <p><strong>Address:</strong> {formData.address}</p>
          <p><strong>Phone:</strong> {formData.phone}</p>
          <p><strong>PAN Number:</strong> {formData.panNumber}</p>
          <p><strong>Aadhar Number:</strong> {formData.aadharNumber}</p>
          <button className="edit-btn" onClick={() => setIsSubmitted(false)}>Edit Details</button>
        </div>
      )}
    </div>
  );
};

export default UpdateProfile;